
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timeline/all_articles",
      function () {
        return require("private-next-pages/timeline/all_articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timeline/all_articles"])
      });
    }
  